import { forwardRef, InputHTMLAttributes } from "react";
import styles from "./FormField.module.css";
import { Form } from "react-bootstrap";
import cn from "classnames";
import { IFieldTheme } from "./FormField";

interface IFormCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  showError?: boolean;
  errorText?: string;
  disabled?: boolean;
  fieldTheme?: IFieldTheme;
  className?: string;
}

const FormCheckbox = forwardRef<HTMLInputElement, IFormCheckboxProps>(
  (props, ref) => {
    const {
      fieldTheme = IFieldTheme.DEFAULT,
      label,
      showError,
      errorText,
      disabled,
      className,
      ...restProps
    } = props;

    return (
      <div
        className={cn(styles.formField, styles.checkboxField,className, styles[fieldTheme])}
      >
        <div className={styles.checkboxWrapper}>
          <input
            id={restProps.id}
            type="checkbox"
            ref={ref}
            disabled={disabled}
            className={cn(styles.formCheckbox, disabled && styles.disabled)}
            {...restProps}
          />
          {label && (
            <Form.Label className={cn(styles.checkboxLabel)} htmlFor={restProps.id}>
              {label}
            </Form.Label>
          )}
        </div>

        {showError && <div className={styles.errorText}>{errorText}</div>}
      </div>
    );
  }
);

export default FormCheckbox;
